<template>
	<Sidebar>
		<SidebarItem slot="links"
					 v-for="item in itemMenu"
					 :key="item.name"
					 :link="item"
		>
			<template v-if="item.children && item.children.length > 0">
				<SidebarItem
					v-for="item in item.children"
					:key="item.name"
					:link="item"
				></SidebarItem>
			</template>
		</SidebarItem>
	</Sidebar>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import {enumDef} from "@/common/enumDefs";
import {navigationPaths} from "@/common/navigation/navigationPaths";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		// try to init it later in case this component is loaded async
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

export default {
	mounted() {
		let docClasses = document.body.classList;
		let isWindows = navigator.platform.startsWith("Win");
		if (isWindows) {
			// if we are on windows OS we activate the perfectScrollbar function
			initScrollbar("sidebar");
			initScrollbar("sidebar-wrapper");
			initScrollbar("main-panel");

			docClasses.add("perfect-scrollbar-on");
		} else {
			docClasses.add("perfect-scrollbar-off");
		}
		this.minimizeSidebar();
	},
	data() {
		return {
			itemMenu: [
				// {
				// 	name: this.$t("dashSideNav.dashboard"),
				// 	path: navigationPaths.dashboard,
				// 	permissions: [enumDef.permissions.Dashboard],
				// 	onlyVisibleFor: [enumDef.traderType.Supplier, enumDef.traderType.Investor],
				// 	icon: "fa fa-rocket"
				// },
				{
					name: this.$t("dashSideNav.seller"),
					path: "",
					onlyVisibleFor: [enumDef.traderType.Supplier, enumDef.traderType.Investor /* Remove Investor from here later */],
					icon: "fa fa-upload",
					children: [
						{
							name: this.$t("dashSideNav.debtorManagement"),
							path: navigationPaths.seller.debtors,
							permissions: [enumDef.permissions.SellerDebtorManagement],
							icon: ""
						},
						// {
						// 	name: this.$t("dashSideNav.Upload"),
						// 	path: navigationPaths.seller.upload,
						// 	permissions: [enumDef.permissions.SellerSellReceivables],
						// 	icon: "",
						// },
						// {
						// 	name: this.$t("dashSideNav.Sell"),
						// 	path: navigationPaths.seller.sell,
						// 	permissions: [enumDef.permissions.SellerSellReceivables, enumDef.permissions.SellerInvestorManagement],
						// 	icon: ""
						// },
						{
							name: this.$t("dashSideNav.TrackAndPay"),
							path: navigationPaths.seller.trackPay,
							permissions: [enumDef.permissions.SellerTrackAndPay],
							icon: ""
						}
					]
				},
				// {
				// 	name: this.$t("dashSideNav.Investor"),
				// 	path: "",
				// 	onlyVisibleFor: [enumDef.traderType.Investor],
				// 	icon: "fa fa-pie-chart",
				// 	children: [
				// 		{
				// 			name: this.$t("dashSideNav.Exchange"),
				// 			path: navigationPaths.investor.exchange,
				// 			permissions: [enumDef.permissions.InvestorExchangeReceivables, enumDef.permissions.InvestorExchangeRevolvingPutOptions],
				// 			icon: ""
				// 		},
				// 		{
				// 			name: this.$t("dashSideNav.Payments"),
				// 			path: navigationPaths.investor.payments,
				// 			permissions: [enumDef.permissions.InvestorExchangeReceivables, enumDef.permissions.InvestorExchangeRevolvingPutOptions],
				// 			icon: ""
				// 		},
				// 		{
				// 			name: this.$t("dashSideNav.All.Investments"),
				// 			path: navigationPaths.investor.investments,
				// 			permissions: [enumDef.permissions.InvestorExchangeReceivables, enumDef.permissions.InvestorExchangeRevolvingPutOptions],
				// 			icon: ""
				// 		},
				// 		{
				// 			name: this.$t("dashSideNav.Credit.Ratings"),
				// 			path: navigationPaths.investor.ratings,
				// 			permissions: [enumDef.permissions.InvestorCustomRatings],
				// 			icon: ""
				// 		}
				// 	]
				// },
				{
					name: this.$t("dashSideNav.Debtor"),
					path: "",
					onlyVisibleFor: [enumDef.traderType.Supplier, enumDef.traderType.Investor],
					icon: "fa fa-building",
					children: [
						// {
						// 	name: this.$t("dashSideNav.ipu.confirmations"),
						// 	path: navigationPaths.debtor.ipu,
						// 	permissions: [enumDef.permissions.DebtorIpuConfirmations],
						// 	icon: ""
						// },
						{
							name: this.$t("dashSideNav.TrackAndPay"),
							path: navigationPaths.debtor.trackPay,
							permissions: [enumDef.permissions.DebtorTrackAndPay],
							icon: ""
						}
					]
				},
				{
					name: this.$t("dashSideNav.administration"),
					path: "",
					onlyVisibleFor: [enumDef.traderType.Supplier, enumDef.traderType.Investor],
					icon: "fa fa-cog",
					children: [
						{
							name: this.$t("DashSideNav.user.account"),
							path: navigationPaths.admin.profile,
							permissions: [enumDef.permissions.AdminProfile],
							icon: ""
						},
						{
							name: this.$t("DashSideNav.user.users"),
							path: navigationPaths.admin.users,
							permissions: [enumDef.permissions.AdminUserManagement],
							icon: ""
						},
						{
							name: this.$t("DashSideNav.user.company"),
							path: navigationPaths.admin.company,
							permissions: [enumDef.permissions.AdminCompany],
							icon: ""
						},
						{
							name: this.$t("DashSideNav.Bank.Accounts"),
							path: navigationPaths.admin.accounts,
							permissions: [enumDef.permissions.AdminBankAccountManagement],
							icon: ""
						},
						{
							name: this.$t("DashSideNav.TrustBills.Invoices"),
							path: navigationPaths.admin.invoices,
							permissions: [enumDef.permissions.AdminInvoiceManagement],
							icon: ""
						},
					]
				}
			]
		};
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
		isItemVisible(item) {

		}
	},
};
</script>
